import { render } from "./PanelGroupsSection.vue?vue&type=template&id=b61fa0cc&scoped=true"
import script from "./PanelGroupsSection.vue?vue&type=script&lang=js"
export * from "./PanelGroupsSection.vue?vue&type=script&lang=js"

import "./PanelGroupsSection.vue?vue&type=style&index=0&id=b61fa0cc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61fa0cc"]])

export default __exports__